import { Component, Input, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { saveAs as importedSaveAs } from "file-saver";
import { HttpService } from '../../services/http.service';
import { AuthenService } from '../../services/authen.service';
import { HelperService } from '../../services/helper.service';
import { UploadFileDialogComponent } from "../../dialogs/upload-file-dialog/upload-file-dialog";

@Component({
    selector: 'contract-files',
    templateUrl: './contract-files.html',
    //styleUrls: ['./attached-files.css']
})
export class ContractFilesComponent implements OnInit {
    @ViewChild('dlgUpload') dlgUpload: UploadFileDialogComponent;
    contractId: number;
    files: any = null;
    waiting: boolean = false;

    constructor(private cdr: ChangeDetectorRef, private http: HttpService, private auth: AuthenService, private helper: HelperService) {
    }

    ngOnInit() {
    }

    load(contractId: number) {
        this.contractId = contractId;

        this.http.get(`api/Contract/GetFileList/${contractId}`, res => {
            //console.log(res.Result);
            this.files = res.Result;
            this.cdr.detectChanges();
        });
    }

    isAllowAdd() {
        return true;
    }

    isAllowRemove(p: any) {
        return true;
    }

    onAdd() {
        let path = {
            saveUrl: `${this.http.getUrl()}api/Contract/UploadFile`,
            removeUrl: 'https://aspnetmvc.syncfusion.com/services/api/uploadbox/Remove'
        };

        let params = [];
        params.push({ 'contractId': this.contractId });
        params.push({ 'prnCode': this.auth.Principal });
        params.push({ 'userName': this.auth.getUser() });

        this.dlgUpload.showEx(path, params, () => {
            this.load(this.contractId);
        });
    }

    onRemove(p: any) {
        this.helper.confirm('Are you sure you want to remove this file ?', () => {
            this.http.delete('api/Contract/RemoveDoc/' + p.Id, res => {
                if (res.Result == true)
                    this.load(this.contractId);
            });
        });
    }

    onDownload(p: any) {
        this.http.download(`api/Contract/DownloadDoc/${p.Id}`, res => {
            importedSaveAs(res, p.DocumentName);
            this.cdr.detectChanges();
        });
    }
}
